<form
  [formGroup]="assetForm"
  (ngSubmit)="onSubmit()"
  (keydown.enter)="$event.preventDefault()"
>
  <!--start of the page-->
  <div class="form page">
    <elastic-page-header
      [height]="'75px'"
      [reverse]="true"
    ></elastic-page-header>

    <div class="container">
      <div class="u-flex u-column u-flex-100">
        <!--breadcrumb-->
        <elastic-breadcrumbs
          [currentPage]="
            (this.assetId
              ? ('OPERATIONS.EDIT' | translate)
              : ('OPERATIONS.ADD' | translate)) +
            ' ' +
            ('ASSET.TITLE' | translate)
          "
          [names]="[
            'NAVIGATION.BUILDING_DATA' | translate,
            'NAVIGATION.ASSET' | translate,
          ]"
          [routes]="['', '/asset']"
          [header]="'primary'"
        >
        </elastic-breadcrumbs>

        <!--start of content-->
        <div
          class="main-content group card alternative no-border mat-elevation-z2 u-flex u-column u-gap-1r"
        >
          <!--title box-->
          <div
            class="content-title-box section title-buttons-wrapper u-flex u-row u-jc-between u-ai-center u-gap-1r"
          >
            <div class="u-flex u-column u-flex-100">
              <div class="section-title">
                @if (asset.name) {
                  <h1 id="{{ 'assetForm-formTitle' }}">
                    {{ asset.name }}
                  </h1>
                }
                <h2 class="sub-heading">
                  <span>{{ "ASSET.ASSET_STATE" | translate }}: </span>
                  <p
                    class="{{ asset.status }}"
                    id="{{ 'assetForm-formTitle' }}"
                  >
                    {{
                      asset.status
                        ? ("COMMON." + asset.status.toUpperCase() | translate)
                        : ""
                    }}
                  </p>
                </h2>
              </div>
            </div>

            <div
              class="buttons-wrapper u-flex u-row u-jc-start u-gt-md-jc-end u-gt-md-ai-center u-gap-1r u-flex-100"
            >
              @for (action of asset.actions; track action) {
                <button
                  id="{{ 'assetForm-actionId-' + action.actionName }}"
                  mat-raised-button
                  color="{{ action.actionName }}"
                  type="button"
                  (click)="changeStatusOverride(asset.id, action.nextState)"
                >
                  {{ action.actionName }}
                </button>
              }

              <mat-divider [vertical]="true"></mat-divider>
              @if (!assetForm.pristine) {
                <button
                  id="{{ 'assetForm-save' }}"
                  mat-raised-button
                  color="accent"
                  [disabled]="backgroundTaskRunning$ | async"
                  type="submit"
                  (mousedown)="setSaveAndClose(false)"
                >
                  {{ "ACTIONS.SAVE" | translate }}
                </button>
              }

              @if (!assetForm.pristine) {
                <button
                  id="{{ 'assetForm-saveAndClose' }}"
                  mat-raised-button
                  color="accent"
                  [disabled]="backgroundTaskRunning$ | async"
                  type="submit"
                  (mousedown)="setSaveAndClose(true)"
                >
                  {{ "ACTIONS.SAVE_CLOSE" | translate }}
                </button>
              }

              <button
                id="assetForm-close"
                mat-raised-button
                color="primary"
                type="button"
                [disabled]="backgroundTaskRunning$ | async"
                (click)="cancel()"
              >
                {{ "ACTIONS.CLOSE" | translate }}
              </button>
            </div>
          </div>
          <!---->

          <div class="divider reverse"></div>

          <div
            class="u-flex u-column"
            [ngStyle]="{ height: tabGroupHeight }"
            [@.disabled]="true"
          >
            <mat-tab-group
              class="u-flex-auto"
              [mat-stretch-tabs]="false"
              style="overflow: auto !important"
            >
              <mat-tab>
                <ng-template mat-tab-label>
                  @if (!assetTabFieldsValid) {
                    <mat-icon class="validationWarningIcon">warning</mat-icon>
                  }
                  <span [attr.tab-name]="'asset'">
                    {{ "ASSET.FORM.TABS.ASSET" | translate }}
                  </span>
                </ng-template>

                <div class="tab-container u-flex u-row u-jc-center u-ai-start">
                  <div class="u-flex-100">
                    <div
                      class="u-flex u-row u-wrap u-gap-1r u-jc-start u-ai-start"
                    >
                      <div
                        class="u-flex u-column u-flex-100 u-gt-sm-flex-20 u-gap-1r"
                      >
                        <!-- temp until we get global filter-->
                        <bs-reactive-dropdown
                          formControlName="selectBuilding"
                          #buildingDropdown
                          placeholder="{{
                            'ASSET.FORM.BUILDINGNAME' | translate
                          }}"
                          [dataService]="assetService"
                          isShowError="false"
                          apiResource="buildings"
                          (onDropdownSelect)="onLocationSelect($event)"
                        >
                        </bs-reactive-dropdown>

                        <bs-reactive-dropdown
                          formControlName="selectZone"
                          #zoneDropdown
                          [initialParentId]="asset?.buildingId"
                          [parentControl]="buildingDropdown"
                          placeholder="{{ 'ASSET.FORM.ZONENAME' | translate }} "
                          [dataService]="assetService"
                          isShowError="false"
                          apiResource="zones"
                          (onDropdownSelect)="onLocationSelect($event)"
                        >
                        </bs-reactive-dropdown>

                        <bs-reactive-dropdown
                          formControlName="selectLocationType"
                          #locationTypeDropdown
                          [initialParentId]="asset?.zoneId"
                          [parentControl]="zoneDropdown"
                          placeholder="{{
                            'ASSET.FORM.LOCATIONTYPENAME' | translate
                          }} "
                          [dataService]="assetService"
                          isShowError="false"
                          apiResource="locationTypes"
                          (onDropdownSelect)="onLocationSelect($event)"
                        >
                        </bs-reactive-dropdown>

                        <bs-reactive-dropdown
                          formControlName="selectLocation"
                          #locationDropdown
                          [initialParentId]="asset?.locationTypeId"
                          [parentControl]="locationTypeDropdown"
                          placeholder="{{
                            'ASSET.FORM.LOCATIONNAME' | translate
                          }}"
                          [dataService]="assetService"
                          isShowError="false"
                          apiResource="locations"
                          [additionalFilterId]="
                            assetForm?.value?.selectZone?.id
                          "
                          (onDropdownSelect)="onLocationSelect($event)"
                        >
                        </bs-reactive-dropdown>
                        @for (
                          error of getErrors("selectLocation");
                          track error
                        ) {
                          <mat-error class="reative-dropdown-error">
                            <span [innerHTML]="error"></span>
                          </mat-error>
                        }

                        <mat-form-field>
                          <mat-label>{{
                            "ASSET.FORM.NAME" | translate
                          }}</mat-label>
                          <input matInput formControlName="name" />
                          @for (error of getErrors("name"); track error) {
                            <mat-error>
                              <span [innerHTML]="error"></span>
                            </mat-error>
                          }
                        </mat-form-field>

                        <mat-form-field>
                          <mat-label>{{
                            "ASSET.FORM.ASSETREF" | translate
                          }}</mat-label>
                          <input matInput formControlName="assetRef" />
                          @for (error of getErrors("assetRef"); track error) {
                            <mat-error>
                              <span [innerHTML]="error"></span>
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <div class="u-flex u-column u-flex-100 u-gt-sm-flex-20">
                        <div>
                          <mat-form-field>
                            <mat-label>{{
                              "ASSET.FORM.COMMENTS" | translate
                            }}</mat-label>
                            <textarea
                              matInput
                              rows="7"
                              cols="40"
                              maxlength="300"
                              formControlName="assetComment"
                            ></textarea>
                            @for (
                              error of getErrors("assetComment");
                              track error
                            ) {
                              <mat-error>
                                <span [innerHTML]="error"></span>
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>

                        @if (debug) {
                          <div class="u-flex u-row">
                            <div class="responsive-col col-1">
                              <div>
                                model:
                                <pre class="code">{{ asset | json }}</pre>
                              </div>
                            </div>
                            <div class="responsive-col col-1">
                              <div>
                                form:
                                <pre class="code">{{
                                  assetForm.value | json
                                }}</pre>
                              </div>
                            </div>
                          </div>
                        }
                      </div>

                      <div
                        class="u-flex u-column u-flex-100 u-gt-sm-flex-20 u-jc-start"
                      >
                        <!-- image here -->
                        <input
                          #assetUpload
                          type="file"
                          name="file"
                          style="display: none"
                          (change)="onFileSelected($event)"
                        />
                        <div class="asset">
                          <div class="container">
                            <div class="upload-container upload-image-box">
                              <div class="placeholder mat-elevation-z4">
                                <div class="details">
                                  <div class="content">
                                    <img
                                      id="{{ 'assetForm-imagePreview' }}"
                                      [attr.src]="imagePath"
                                      [attr.data-documentId]="asset.documentId"
                                      alt=""
                                    />
                                    <p
                                      [ngClass]="
                                        imagePath ===
                                        'assets/img/placeholder.svg'
                                          ? 'image-upload-text'
                                          : 'image-upload-text hidden'
                                      "
                                    >
                                      {{ "UPLOAD.UPLOAD_IMAGE" | translate }}
                                    </p>
                                  </div>
                                </div>

                                @if (asset.id) {
                                  <div class="overlay">
                                    <div
                                      class="overlay-content u-flex u-column u-jc-between"
                                    >
                                      <div
                                        class="overlay-actions u-flex u-row u-gap-1r"
                                      >
                                        <button
                                          id="{{ 'assetForm-uploadDocument' }}"
                                          (click)="assetUpload.click()"
                                          type="button"
                                          matTooltip="{{
                                            'OPERATIONS.UPLOAD' | translate
                                          }}"
                                          mat-icon-button
                                        >
                                          <mat-icon>file_upload</mat-icon>
                                        </button>
                                        <button
                                          id="{{ 'assetForm-removeDocument' }}"
                                          color="warn"
                                          (click)="onFileRemoved()"
                                          type="button"
                                          matTooltip="{{
                                            'OPERATIONS.REMOVE' | translate
                                          }}"
                                          mat-icon-button
                                        >
                                          <mat-icon>clear</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (isUploading) {
                                  <section
                                    class="margin image-loader u-flex u-row u-jc-start u-ai-center"
                                  >
                                    <p>
                                      {{ "UPLOAD.UPLOADING_IMAGE" | translate }}
                                    </p>
                                    <mat-progress-bar
                                      class="margin"
                                      color="accent"
                                      mode="indeterminate"
                                    >
                                    </mat-progress-bar>
                                  </section>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end of image here -->
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  @if (!servicesTabValid()) {
                    <mat-icon class="validationWarningIcon">warning</mat-icon>
                  }
                  <span [attr.tab-name]="'services'">
                    {{ "ASSET.FORM.TABS.SERVICES" | translate }}
                  </span>
                </ng-template>
                <elastic-list
                  gridName="tableService"
                  [columns]="columnsServices"
                  class="sticky-search"
                  (filterChange)="onFilterChangeService($event)"
                >
                  <div class="actions u-self-center">
                    <button
                      id="{{ 'tableService' + '-addButton' }}"
                      class="create"
                      (click)="addServices()"
                      type="button"
                      color="accent"
                      mat-raised-button
                    >
                      <mat-icon>add</mat-icon>
                      {{ "OPERATIONS.ADD" | translate }}
                    </button>
                  </div>
                </elastic-list>

                <div
                  class="data-grid-container inner-table banyard-grid-table sticky-header-custom"
                >
                  <mat-table
                    #tableService
                    #tableServiceSort="matSort"
                    [dataSource]="dataSourceServices"
                    matSort
                  >
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="checkbox">
                      <mat-header-cell class="actions-cell" *matHeaderCellDef>
                        <mat-checkbox
                          id="{{ 'tableService-' + 'checkboxColumn' }}"
                          color="primary"
                          (click)="$event.stopPropagation()"
                        >
                        </mat-checkbox>
                      </mat-header-cell>
                      <mat-cell
                        class="actions-cell"
                        *matCellDef="let row; index as i"
                      >
                        <mat-checkbox
                          id="{{ 'tableService-row' + 'checkboxColumn' + i }}"
                          color="primary"
                          (click)="$event.stopPropagation()"
                        >
                        </mat-checkbox>
                      </mat-cell>
                    </ng-container>

                    <!-- fullName Column -->
                    @for (column of columnsServices; track column) {
                      @if (
                        column.isModelProperty &&
                        column.modelPropertyType !== "Boolean"
                      ) {
                        <ng-container [matColumnDef]="column.property">
                          <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span
                              id="{{ 'tableService-' + column.property }}"
                              >{{ column.name }}</span
                            >
                          </mat-header-cell>
                          <mat-cell
                            *matCellDef="let row; index as i"
                            [attr.data-value]="row[column.propertyId]"
                          >
                            @if (column.property === "status") {
                              <div class="mat-column-status">
                                <span
                                  [ngClass]="row[column.property]"
                                  class="round-status-icon"
                                  id="{{
                                    'tableService-row' + column.property + i
                                  }}"
                                >
                                  {{ row[column.property].charAt(0) }}
                                </span>
                                <span>{{
                                  "COMMON." + row[column.property].toUpperCase()
                                    | translate
                                }}</span>
                              </div>
                            } @else {
                              <span
                                class="{{ row[column.property] }}"
                                id="{{
                                  'tableService-row' + column.property + i
                                }}"
                                [innerHTML]="row[column.property]"
                              ></span>
                            }
                          </mat-cell>
                        </ng-container>
                      }
                      @if (
                        column.isModelProperty &&
                        column.modelPropertyType === "Boolean"
                      ) {
                        <ng-container [matColumnDef]="column.property">
                          <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span id="{{ 'tableService-' + column.property }}">
                              {{ column.name }}
                            </span>
                          </mat-header-cell>
                          <mat-cell *matCellDef="let row; index as i">
                            <span
                              id="{{
                                'tableService-row' + column.property + i
                              }}"
                              [attr.data-value]="row[column.property]"
                              [innerHTML]="
                                row[column.property] ? '&#9745;' : '&#9744;'
                              "
                            ></span>
                          </mat-cell>
                        </ng-container>
                      }
                    }

                    <!-- actions Column -->
                    <ng-container matColumnDef="actions">
                      <mat-header-cell class="actions-cell" *matHeaderCellDef>
                      </mat-header-cell>
                      <mat-cell
                        class="actions-cell"
                        *matCellDef="let row; index as i"
                      >
                        <button
                          type="button"
                          id="{{ 'tableService-rowActions' + i }}"
                          mat-icon-button
                          [matMenuTriggerFor]="actionsMenu"
                          (click)="$event.stopPropagation()"
                        >
                          <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu
                          #actionsMenu="matMenu"
                          yPosition="below"
                          xPosition="before"
                        >
                          <button
                            id="{{ 'tableService-row' + i + '-actionView' }}"
                            type="button"
                            (click)="updateRowService(row)"
                            mat-menu-item
                          >
                            <span>{{ "OPERATIONS.VIEW" | translate }}</span>
                          </button>
                          <button
                            id="{{ 'tableService-row' + i + '-actionRemove' }}"
                            type="button"
                            (click)="removeRowService(row)"
                            mat-menu-item
                          >
                            <span>{{ "OPERATIONS.REMOVE" | translate }}</span>
                          </button>
                        </mat-menu>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row
                      *matHeaderRowDef="visibleColumnsServices; sticky: true"
                    >
                    </mat-header-row>
                    <mat-row
                      *matRowDef="let row; columns: visibleColumnsServices"
                      class="clickable"
                    ></mat-row>
                  </mat-table>

                  <mat-paginator
                    #tableServicePaginator
                    class="paginator"
                    [length]="resultsService"
                    sticky="true"
                    class="mat-paginator-sticky-inline"
                    [pageSize]="pageSizeService"
                    [pageSizeOptions]="[10, 20, 50]"
                  >
                  </mat-paginator>
                </div>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <span [attr.tab-name]="'history'">
                    {{ "ASSET.FORM.TABS.HISTORY" | translate }}
                  </span>
                </ng-template>

                <div>
                  <ep-metadata [auditLog]="auditMetadata"></ep-metadata>
                  <ep-auditing
                    #auditing
                    eventType="Asset"
                    [eventTypeId]="getAuditEventTypeId()"
                    [auditToken]="asset?.auditToken"
                  ></ep-auditing>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
